import { Component, input, InputSignal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { ReferralInputWithRevertComponent } from '../Input-With-Revert/referralInputWithRevert.component';

@Component({
    selector: 'referral-ryan-contacts',
    templateUrl: 'ryanContacts.component.html',
    styleUrls: ['../referralPage.component.scss'],
    imports: [ReactiveFormsModule, ReferralInputWithRevertComponent],
})
export class ReferralRyanContactsComponent {
    referral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    systemReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    originalReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    form: InputSignal<FormGroup> = input<FormGroup>();

    updateAppealAssignedUserName(name: string): void {
        this.form().patchValue({ ryanContactJSName: name });
    }
}
